import { useContext, useEffect, useRef, useState } from 'react';

import { DataProvider } from '../store/ContextProvider';

function ListCandidates({ columns, FaEye, FaSearch }) {

  const { BeURL } = useContext(DataProvider);
  const searchRef = useRef();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCandidates, setTotalCandidates] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);


  const fetchCandidates = async (filterOption) => {
    const filterOptions = filterOption || {}
    setLoading(true);
    try {
      const res = await fetch(`${BeURL}/get-newCandidate`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page: currentPage, searchTerm, candidatesPerPage: itemsPerPage, filterOptions })
      });
      const data = await res.json();
      if (data.success) {
        setCandidates(data.candidates);
        setTotalCandidates(data.totalCandidates);
        // Recalculate pages based on selected itemsPerPage
        setTotalPages(data.totalPages);
      } else {
        setCandidates([]);
        setTotalCandidates(0);
        setTotalPages(0);
      }
    } catch (err) {
      console.error('Error fetching candidates:', err);
    } finally {
      setLoading(false);
    }
  };




  // Fetch candidates when page, searchTerm, or itemsPerPage changes
  useEffect(() => {

    if (currentPage <= totalPages) {
      fetchCandidates();
    }
    else {
      setCurrentPage(1)
    }


  }, [currentPage, itemsPerPage, BeURL]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchCandidates()
    }
  }, [searchTerm])

  useEffect(() => {
    setCurrentPage(1)
  }, [itemsPerPage])

  const handlePagination = (dir) => {
    if (dir === 'prev' && currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
    if (dir === 'next' && currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchCandidates()
  }

  const handleKeyDown = (e) => {

    if (e.key === "Enter") {
      handleSearch()
    }
  }

  return (
    <div className="min-h-[80vh]">

      {/* Search Box */}
      <div className="flex flex-wrap gap-4">
        <div className="flex flex-1 max-w-md ">

          <input
            ref={searchRef}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            type="search"

            className="flex-1 border rounded-l px-3 py-2 focus:outline-none"
            placeholder="Search by role, skill, exp..."
            onKeyDown={e => handleKeyDown(e)}
          />
          <button onClick={handleSearch} className={`px-4 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-white rounded-r flex items-center`}
            title="Apply search">
            <FaSearch className="mr-2" />Search
          </button>
        </div>



      </div>


      {/* Candidates Table */}

      <div className="overflow-x-auto bg-white rounded shadow m-5">
        <table className="w-full table-auto">
          <thead className={`text-primary-500 bg-blue-100`}>
            <tr>
              <th className="p-3 text-left font-semibold">S.No</th>

              {columns.length > 0 && columns?.map(({ key, label }) => (
                <th
                  key={key}
                  className="p-3 text-left cursor-pointer select-none font-semibold"

                >
                  {label}

                </th>
              ))}
              <th className="p-3 text-center font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns?.length + 1} className="p-6 text-center">
                  Loading…
                </td>
              </tr>
            ) : candidates.length === 0 ? (
              <tr>
                <td colSpan={columns?.length + 1} className="p-6 text-center">
                  No users found.
                </td>
              </tr>
            ) : (
              candidates.map((u, i) => (
                <tr
                  key={u._id}
                  className={`border-b hover:bg-gray-50 ${i % 2 === 0 ? "" : "bg-slate-50"}`}
                >
                  <td className="p-3">{i + 1}</td>

                  <td className="p-3">{u.applicantName}</td>
                  <td className="p-3">{u.score}%</td>
                  <td className="p-3">{u.createdAt ? new Date(u?.createdAt).toLocaleString("en-GB") : '-'}</td>

                  <td className="p-3 text-center space-x-2">
                    <button
                      onClick={() => window.open(`/candidate/${u._id}`, "_blank")}
                      className="text-slate-600 hover:text-slate-800"
                      title="View"
                    >
                      <FaEye />
                    </button>

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="mx-auto my-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
          <select
            id="recordsPerPage"
            value={itemsPerPage}
            onChange={e => setItemsPerPage(parseInt(e.target.value, 10))}
            className="ml-2 px-3 py-1 border rounded"
          >
            {[10, 20, 25, 50, 75, 100].map(n => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        <div className="flex justify-center items-center gap-4">

          <button className={`px-3 py-1 bg-white border rounded disabled:opacity-50`}
            onClick={() => handlePagination('prev')}
            disabled={currentPage === 1}
          >
            Prev
          </button>

          <span> Page {currentPage} of {totalPages}</span>

          <button className={`px-3 py-1 bg-white border rounded disabled:opacity-50`}
            onClick={() => handlePagination('next')}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </button>

        </div>


        <div className="text-sm">Total Candidates: {totalCandidates}</div>
      </div>


    </div >
  );
}

export default ListCandidates;